(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9756],{

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92310);

/***/ }),

/***/ 94886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clanky",
      function () {
        return __webpack_require__(6414);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81990);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60071);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96169);
/* harmony import */ var _core_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43195);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _core_Flex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90656);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40592);
/* harmony import */ var _blog_clanky_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59982);
/* harmony import */ var _podcast_podcast_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86953);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 3.2em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 360px;\n  height: 500px;\n  padding: 16px 24px;\n  border-right: var(--color-accent) 4px solid;\n  border-left: var(--color-accent) 4px solid;\n  box-shadow: 0px 2px 2px var(--color-shadow), 0px -2px 2px var(--color-shadow);\n  border-radius: 16px;\n  transition: 250ms ease-in-out;\n\n  &:hover {\n    transform: scale(1.05);\n    transition: 250ms ease-in-out;\n    box-shadow: 0px 4px 10px var(--color-shadow),\n      0px -4px 10px var(--color-shadow);\n  }\n\n  @media ",
        " {\n    width: 345px;\n    height: 480px;\n  }\n\n  @media ",
        " {\n    width: 320px;\n    height: 440px;\n  }\n\n  @media ",
        " {\n    width: 300px;\n    height: 400px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 1.4;\n  height: 5.2em;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  opacity: 0.85;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  // images will adapt to this size while preserving their aspect-ratio\n  width: 220px;\n  height: 220px;\n\n  [theme-type='DARK'] & {\n    filter: brightness(0.9);\n  }\n\n  img {\n    object-position: left;\n  }\n\n  @media ",
        " {\n    width: 180px;\n    height: 180px;\n  }\n\n  @media ",
        " {\n    width: 160px;\n    height: 160px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











/***
 * Works with blog posts and podcasts.
 * Featured image should work with any aspect-ratio.
 */ var PostPreviewCard = function(param) {
    var post = param.post, isPodcast = param.isPodcast;
    var ref, ref1, ref2;
    var featuredImage = (ref = post.featuredImage) === null || ref === void 0 ? void 0 : ref.node;
    var authorName = post.author ? ((ref1 = post.author.node) === null || ref1 === void 0 ? void 0 : ref1.firstName) && post.author.node.lastName ? "".concat(post.author.node.firstName, " ").concat(post.author.node.lastName) : (ref2 = post.author.node) === null || ref2 === void 0 ? void 0 : ref2.name : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(WrapperFlex, {
        direction: "column",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                direction: "column",
                gap: "18px",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        direction: "column",
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FixedSizedHeading, {
                                variant: "h6",
                                align: "center",
                                children: post.title
                            }),
                            post.excerpt && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Excerpt, {
                                align: "center",
                                dangerouslySetInnerHTML: {
                                    __html: post.excerpt
                                }
                            })
                        ]
                    }),
                    featuredImage && featuredImage.sourceUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: featuredImage.sourceUrl,
                            alt: post.title || "",
                            objectFit: "contain",
                            priority: true
                        })
                    }),
                    !featuredImage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: isPodcast ? _podcast_podcast_constants__WEBPACK_IMPORTED_MODULE_9__/* .EMPTY_PODCAST_IMAGE_PLACEHOLDER_URL */ .SA : _blog_clanky_constants__WEBPACK_IMPORTED_MODULE_10__/* .EMPTY_BLOG_IMAGE_PLACEHOLDER_URL */ .xf,
                            alt: post.title || "",
                            objectFit: "contain",
                            priority: true
                        })
                    })
                ]
            }),
            isPodcast && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(PaddedFlex, {
                justifyContent: "space-between",
                alignSelf: "stretch",
                alignItems: "flex-end",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: _podcast_podcast_constants__WEBPACK_IMPORTED_MODULE_9__/* .PODCAST_MICROPHONE_IMG */ .zI,
                        width: 20,
                        height: 40
                    }),
                    post.date && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: "small",
                        children: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(new Date(post.date))
                    })
                ]
            }),
            !isPodcast && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(PaddedFlex, {
                justifyContent: "space-between",
                alignSelf: "stretch",
                children: [
                    post.date && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: "small",
                        children: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(new Date(post.date))
                    }),
                    authorName && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        align: "right",
                        children: authorName
                    })
                ]
            })
        ]
    });
};
var FixedSizedHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-0"
})(_templateObject());
var WrapperFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-1"
})(_templateObject1(), _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.L */ .U.L, _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.S */ .U.S, _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.XS */ .U.XS);
var PaddedFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-2"
})(_templateObject2());
var Excerpt = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-3"
})(_templateObject3());
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8d7bb97a-4"
})(_templateObject4(), _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.S */ .U.S, _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.XS */ .U.XS);
/* harmony default export */ __webpack_exports__["Z"] = (PostPreviewCard);


/***/ }),

/***/ 6414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ clanky; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(15714);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./src/components/PageContentWrapper.tsx
var PageContentWrapper = __webpack_require__(41246);
// EXTERNAL MODULE: ./src/components/NavBar.tsx + 1 modules
var NavBar = __webpack_require__(55270);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(70638);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(72760);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(81990);
// EXTERNAL MODULE: ./src/components/core/NextLink.tsx
var NextLink = __webpack_require__(96791);
// EXTERNAL MODULE: ./src/components/core/Flex.tsx
var Flex = __webpack_require__(90656);
// EXTERNAL MODULE: ./src/components/core/Heading.tsx
var Heading = __webpack_require__(96169);
// EXTERNAL MODULE: ./src/components/core/Text.tsx
var Text = __webpack_require__(43195);
// EXTERNAL MODULE: ./src/components/GridWrapper.tsx
var GridWrapper = __webpack_require__(77497);
// EXTERNAL MODULE: ./src/components/domain/post/PostPreviewCard.tsx
var PostPreviewCard = __webpack_require__(34908);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(80371);
// EXTERNAL MODULE: ./src/components/domain/buttons/PostTag.tsx
var PostTag = __webpack_require__(68759);
// EXTERNAL MODULE: ./src/components/domain/post/postUtils.ts
var postUtils = __webpack_require__(64302);
// EXTERNAL MODULE: ./src/components/domain/post/blog/clanky-constants.ts
var clanky_constants = __webpack_require__(59982);
;// CONCATENATED MODULE: ./src/components/domain/post/blog/BlogPosts.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ALL_TAG = "všetky";
var BlogPosts = function(param) {
    var posts = param.posts;
    var ref;
    var ref1 = (0,react.useState)(ALL_TAG), selectedTag = ref1[0], setSelectedTag = ref1[1];
    var postsByTag = (0,postUtils/* createMapOfPostsByTag */.YK)(posts);
    var topTags = [
        ALL_TAG
    ].concat((0,_to_consumable_array/* default */.Z)((0,postUtils/* getTopNTags */.cU)(postsByTag, clanky_constants/* TOP_TAGS_COUNT */.NH)));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        direction: "column",
        gap: "36px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                direction: "column",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                inline: true,
                                align: "center",
                                variant: "h2",
                                children: "Naše"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Heading/* default */.Z, {
                                inline: true,
                                variant: "h2",
                                color: "accent",
                                children: [
                                    " ",
                                    "čl\xe1nky"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        align: "center",
                        children: "P\xedšeme o všeličom. Tutor\xe1ly, rozhovory, blogy."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsFlex, {
                justifyContent: "center",
                gap: "12px",
                children: topTags.map(function(tag, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostTag/* default */.Z, {
                        tag: tag,
                        handleOnClick: setSelectedTag,
                        selected: tag === selectedTag
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridWrapper/* default */.Z, {
                children: (ref = selectedTag === ALL_TAG ? posts : postsByTag.get(selectedTag)) === null || ref === void 0 ? void 0 : ref.map(function(post, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                        href: routes/* routes.clanky.slug */._.clanky.slug(post.slug || ""),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPreviewCard/* default */.Z, {
                            post: post
                        })
                    }, i);
                })
            })
        ]
    });
};
var TagsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7028c934-0"
})(_templateObject());
/* harmony default export */ var blog_BlogPosts = (BlogPosts);

// EXTERNAL MODULE: ./src/components/Head.tsx
var Head = __webpack_require__(26221);
;// CONCATENATED MODULE: ./src/pages/clanky/index.tsx







var PostsPage = function(param) {
    var posts = param.posts;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* default */.Z, {
                title: "Čl\xe1nky | Street of Code",
                description: "P\xedšeme o všeličom. Tutor\xe1ly, rozhovory, blogy.",
                url: (0,routes/* prefixWithHost */.O)(routes/* routes.clanky.index */._.clanky.index)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavBar/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageContentWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blog_BlogPosts, {
                    posts: posts
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var clanky = (PostsPage);


/***/ }),

/***/ 72760:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(91135);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(69471);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(28712);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7138,5270,1666,9774,2888,179], function() { return __webpack_exec__(94886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);